export default {
  "ServiceAgreement.BackButtonTitle": "Back",
  "ServiceAgreement.DocumentTitle":
    "Consents regarding the handling of Personal Data",
  "Menu.Locale": "Language",
}
